import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'lib-flexible/flexible';
import './utils/vant';
//全局mixin
import './utils/mixin';
import './assets/common.less';
import './utils/directives';
import VConsole from 'vconsole';
import 'vant/lib/index.less';
import './utils/filter';
import smoothscroll from 'smoothscroll-polyfill';
// 引入i18n实例
import i18n from './i18n';
import {showLoading, hideLoading} from '@/utils/loading';

smoothscroll.polyfill();

if (process.env.NODE_ENV !== 'production') {
  new VConsole();
}
import NavBar from '@/components/NavBar';
import SendMsg from '@/components/SendMsg';
import im from '@/views/im';
Vue.component('NavBar',NavBar);
Vue.component('SendMsg',SendMsg);

Vue.prototype.showLoading = showLoading;
Vue.prototype.hideLoading = hideLoading;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
